<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_RENTROLL' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
      @if (columns) {
        <app-excel-list
          [columnDefinition]="excelColumnDefinitions"
          [selectedListViewColumns]="selectedColumns"
          [excelContext]="excelContext"
          [filter]="form.value"
          [fileName]="'RentRoll'"
        ></app-excel-list>
      }
    </div>
  </div>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="form.controls['companyId']" [itemsSource]="companies"></astral-select>
      <astral-select [control]="form.controls['propertyId']" [itemsSource]="realEstateProperties"></astral-select>
      <astral-select [control]="form.controls['rentalObjectCategory']" [itemsSource]="rentalObjectCategorySelection"></astral-select>
      <astral-select [control]="form.controls['year']" [itemsSource]="yearSelection"></astral-select>
      <astral-select [control]="form.controls['month']" [itemsSource]="monthSelection"></astral-select>
      <astral-input [control]="form.controls['city']"></astral-input>
      <astral-input [control]="form.controls['rentalId']"></astral-input>
      <astral-select
        [control]="form.controls['onlyIncludeContractualRentArticles']"
        [itemsSource]="onlyIncludeContractualRentArticlesSelection"
      ></astral-select>
      <astral-select [control]="form.controls['personalData']" [itemsSource]="personalDataSelection"></astral-select>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
    </div>
  </form>

  @if (dataContext) {
    <app-list-view
      [columnDefinition]="columnDefinitions"
      [itemsSource]="dataContext"
      [isToolbarSticky]="true"
      [preferencesKey]="'report.rent-roll'"
      (rowClick)="onRowClicked($event)"
      (onColumnChange)="onColumnChange($event)"
    ></app-list-view>
  }
</section>
